var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),(_vm.loadingStatus)?_c('loader'):_vm._e(),(_vm.toggleExitConfirm)?_c('exitConfirm'):_vm._e(),_c('notification'),(_vm.blocked)?_c('blockedPopup'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }